__turbopack_context__.v({
  "agree": "YIvPga_agree",
  "button": "YIvPga_button",
  "container": "YIvPga_container",
  "content": "YIvPga_content",
  "description": "YIvPga_description",
  "form": "YIvPga_form",
  "input": "YIvPga_input",
  "title": "YIvPga_title",
});
